function CopyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_14840_9002)">
        <path
          d="M2.33366 9.33366C1.69199 9.33366 1.16699 8.80866 1.16699 8.16699V2.33366C1.16699 1.69199 1.69199 1.16699 2.33366 1.16699H8.16699C8.80866 1.16699 9.33366 1.69199 9.33366 2.33366M5.83366 4.66699H11.667C12.3113 4.66699 12.8337 5.18933 12.8337 5.83366V11.667C12.8337 12.3113 12.3113 12.8337 11.667 12.8337H5.83366C5.18933 12.8337 4.66699 12.3113 4.66699 11.667V5.83366C4.66699 5.18933 5.18933 4.66699 5.83366 4.66699Z"
          stroke="#277DFE"
          stroke-width="1.16667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14840_9002">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CopyIcon;
